import React from 'react';
import { ImageIcon, MessageSquareIcon, CodeIcon, PencilIcon, MusicIcon, VideoIcon, SparklesIcon, LightbulbIcon, ChefHatIcon } from 'lucide-react';
export const getIcon = (iconName: string) => {
  const iconMap: {
    [key: string]: React.ReactNode;
  } = {
    image: <ImageIcon className="h-6 w-6 text-white" data-id="element-2108" />,
    'message-square': <MessageSquareIcon className="h-6 w-6 text-white" data-id="element-2109" />,
    code: <CodeIcon className="h-6 w-6 text-white" data-id="element-2110" />,
    pencil: <PencilIcon className="h-6 w-6 text-white" data-id="element-2111" />,
    music: <MusicIcon className="h-6 w-6 text-white" data-id="element-2112" />,
    video: <VideoIcon className="h-6 w-6 text-white" data-id="element-2113" />,
    sparkles: <SparklesIcon className="h-6 w-6 text-white" data-id="element-2114" />,
    lightbulb: <LightbulbIcon className="h-6 w-6 text-white" data-id="element-2115" />,
    'chef-hat': <ChefHatIcon className="h-6 w-6 text-white" data-id="element-2116" />
  };
  return iconMap[iconName] || <ImageIcon className="h-6 w-6 text-white" data-id="element-2117" />;
};